const autoScrollActions = new Set(['POP', 'REPLACE'])

export const shouldAutoScroll = (location, history) => autoScrollActions.has(history.action) && location.hash
